var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { CNAE_FornecedorActions } from "@/store/enums/FornecEnums";
import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let CNAE_FornecedorModule = class CNAE_FornecedorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = CNAE_FornecedorActions.POST_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.post("CNAE_Fornecedor/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = CNAE_FornecedorActions.POSTRANGE_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.post("CNAE_Fornecedor/PostRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = CNAE_FornecedorActions.PUT_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.put("CNAE_Fornecedor/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = CNAE_FornecedorActions.DELETE_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.delete("CNAE_Fornecedor/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = CNAE_FornecedorActions.DELETE_RANGE_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.post("CNAE_Fornecedor/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = CNAE_FornecedorActions.FILTER_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.post("CNAE_Fornecedor/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = CNAE_FornecedorActions.GET_CNAE_FORNECEDOR]() {
        return new Promise(resolve => {
            fornecService.get("CNAE_Fornecedor/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = CNAE_FornecedorActions.GETWITHDISABLED_CNAE_FORNECEDOR]() {
        return new Promise(resolve => {
            fornecService.get("CNAE_Fornecedor/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = CNAE_FornecedorActions.GET_BY_ID_CNAE_FORNECEDOR](data) {
        return new Promise(resolve => {
            fornecService.get("CNAE_Fornecedor/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = CNAE_FornecedorActions.GET_BY_FORNECEDORID_CNAE_FORNECEDOR](fornecedorId) {
        return new Promise(resolve => {
            fornecService.get("CNAE_Fornecedor/GetByFornecedorId", fornecedorId)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CNAE_FornecedorModule.prototype, _k, null);
CNAE_FornecedorModule = __decorate([
    Module
], CNAE_FornecedorModule);
export default CNAE_FornecedorModule;
//# sourceMappingURL=CNAE_FornecedorModule.js.map